module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAANlBMVEVHcEz////////////////////////////t7e7////BwcOWl5nQ0NH////////W19f///////8MCeNqAAAAEnRSTlMAJa7n3Y0N//8c////zcf/wr/eSe6iAAAAeUlEQVR4Ad3VNQLDMBAAQTHj/z+bVKlvQ4ard8yW1O1GG+t8AH2MKUWXxcDEUmsDwqb6nCIXLlUmfGxMhH52oamwQjEiF/OEYv1XZJnYL2EUE8lywC+J3zTp9S/6cbq+ob6/3Tva59/3fDHmyz3fUPiWxTdFvu3ecB6IjhBroPcSiAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-welfare/right-arrow.png
// module id = RN5K
// module chunks = 215